(function () {
  if (window.__varionBreadcrumbsLoaded) return;
  window.__varionBreadcrumbsLoaded = true;

  var storageKey = 'varion-breadcrumb-trail';
  var roots = {
    online: { label: 'Startseite', url: '/' },
    wildlands: { label: 'Wildlands Startseite', url: '/collections/home-wildlands' },
  };
  var onlineGunHandles = new Set([
    'm4-m16-serie',
    'ak-74-ak47-rpk-serie',
    'g608-serie',
    'mp-smg-serie',
    'airsoft-lmg-mcr-taktische-maschinengewehre-fur-maximale-feuerkraft',
    '417-serie',
    'auto-shotgun-replika',
    'exotische-und-sammlermodelle',
  ]);
  var handleLabels = {
    'katalog-gewehre-0-5-j': 'Katalog Gewehre 0,5J',
    'm4-m16-serie': 'M4 / M16 Serie',
    'ak-74-ak47-rpk-serie': 'AK / AK-74 / RPK Serie',
    'g608-serie': 'G608 Serie',
    'mp-smg-serie': 'MP / SMG Serie',
    'airsoft-lmg-mcr-taktische-maschinengewehre-fur-maximale-feuerkraft': 'LMG / MCR Serie',
    '417-serie': '417 Serie',
    'auto-shotgun-replika': 'Auto Shotgun Replika',
    'exotische-und-sammlermodelle': 'Exotische & Sammlermodelle',
    'gewehre-wildlands': 'Gewehre Wildlands',
    'magazine-akkus-speedloade': 'Magazine, Akkus, Speedloader',
    'zielgeraete-und-zubehoer': 'Zielgeraete und Zubehoer',
    'zielgeraete-und-zubehoer-w': 'Zielgeraete und Zubehoer',
    'westen-chestrig-battlebel': 'Westen / Chestrig / Battlebelt',
    'pouches-westenzubehoer': 'Pouches / Westenzubehoer',
    'sicherheitsausruestung': 'Sicherheitsausruestung',
    'allgemeines-zubehoer': 'Allgemeines Zubehoer',
  };

  function cleanPath(path) {
    if (!path) return '';
    return String(path).replace(/[?#].*$/, '').replace(/\/+$/, '') || '/';
  }

  function pathFromUrl(url) {
    if (!url) return '';
    try {
      return cleanPath(new URL(url, window.location.origin).pathname);
    } catch (error) {
      return '';
    }
  }

  function isSameOrigin(url) {
    if (!url) return false;
    try {
      return new URL(url, window.location.origin).origin === window.location.origin;
    } catch (error) {
      return false;
    }
  }

  function getCollectionHandle(pathname) {
    var match = cleanPath(pathname || window.location.pathname).match(/^\/collections\/([^/]+)$/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function humanizeHandle(handle) {
    return String(handle || '')
      .split('-')
      .filter(Boolean)
      .map(function (part) {
        return part.charAt(0).toUpperCase() + part.slice(1);
      })
      .join(' ');
  }

  function getVisibleCollectionTitle() {
    var selectors = [
      'main h1',
      '.collection-hero__title',
      '.main-page-title',
      '.title-wrapper-with-link h1',
      '[data-vx-mh] + * h2',
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var node = document.querySelector(selectors[i]);
      if (node && node.textContent && node.textContent.trim()) {
        return node.textContent.replace(/\s+/g, ' ').trim();
      }
    }

    return '';
  }

  function readTrail() {
    try {
      var raw = window.sessionStorage.getItem(storageKey);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function writeTrail(payload) {
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(payload));
    } catch (error) {
      return;
    }
  }

  function getCollectionRootType(handle) {
    var path = cleanPath(window.location.pathname);
    var referrerPath = isSameOrigin(document.referrer) ? pathFromUrl(document.referrer) : '';
    var stored = readTrail();

    if (path === '/collections/home-wildlands' || handle === 'gewehre-wildlands') {
      return 'wildlands';
    }

    if (
      referrerPath === '/collections/home-wildlands' ||
      referrerPath === '/collections/gewehre-wildlands' ||
      (stored && stored.rootType === 'wildlands' && referrerPath === stored.lastCollectionPath)
    ) {
      return 'wildlands';
    }

    return 'online';
  }

  function buildCollectionTrail(handle, title) {
    if (!handle) return null;

    var rootType = getCollectionRootType(handle);
    var root = roots[rootType];
    var trail = [root];
    var finalTitle = title || handleLabels[handle] || getVisibleCollectionTitle() || humanizeHandle(handle);
    var collectionUrl = '/collections/' + encodeURIComponent(handle);

    if (rootType === 'online' && onlineGunHandles.has(handle)) {
      trail.push({
        label: handleLabels['katalog-gewehre-0-5-j'],
        url: '/collections/katalog-gewehre-0-5-j',
      });
    }

    if (handle !== 'home-wildlands') {
      trail.push({
        label: finalTitle,
        url: collectionUrl,
      });
    }

    return {
      rootType: rootType,
      lastCollectionPath: cleanPath(collectionUrl),
      trail: trail,
    };
  }

  function bindCollectionClicks() {
    var handle = getCollectionHandle();
    if (!handle) return;

    document.addEventListener(
      'click',
      function (event) {
        var link = event.target && event.target.closest ? event.target.closest('a[href*="/products/"]') : null;
        if (!link) return;

        var productPath = pathFromUrl(link.href);
        if (!productPath || productPath.indexOf('/products/') !== 0) return;

        var trail = buildCollectionTrail(handle, getVisibleCollectionTitle());
        if (!trail || !Array.isArray(trail.trail) || !trail.trail.length) return;

        writeTrail({
          productPath: productPath,
          rootType: trail.rootType,
          lastCollectionPath: trail.lastCollectionPath,
          trail: trail.trail,
          savedAt: Date.now(),
        });
      },
      true
    );
  }

  function buildFallbackTrail(nav) {
    var trail = [];
    var rootLabel = nav.dataset.defaultRootLabel || roots.online.label;
    var rootUrl = nav.dataset.defaultRootUrl || roots.online.url;

    trail.push({ label: rootLabel, url: rootUrl });

    if (nav.dataset.fallbackSectionLabel) {
      trail.push({
        label: nav.dataset.fallbackSectionLabel,
        url: nav.dataset.fallbackSectionUrl || rootUrl,
      });
    }

    if (nav.dataset.fallbackCollectionLabel) {
      trail.push({
        label: nav.dataset.fallbackCollectionLabel,
        url: nav.dataset.fallbackCollectionUrl || rootUrl,
      });
    }

    return trail;
  }

  function buildTrailFromReferrer() {
    if (!isSameOrigin(document.referrer)) return null;

    var referrerPath = pathFromUrl(document.referrer);
    var handle = getCollectionHandle(referrerPath);
    if (!handle) return null;

    var title = handleLabels[handle] || humanizeHandle(handle);
    var trail = buildCollectionTrail(handle, title);
    return trail || null;
  }

  function applyProductContext(rootType, trail) {
    var mode = rootType === 'wildlands' ? 'wildlands' : 'online';
    var nav = document.querySelector('.varion-pdp-breadcrumb');
    var productInfo = document.querySelector("product-info[id^='MainProduct-']");
    var productRoot = document.getElementById('va-topbox');

    if (nav) {
      nav.setAttribute('data-root-type', mode);
    }

    document.documentElement.setAttribute('data-varion-pdp-context', mode);

    if (document.body) {
      document.body.setAttribute('data-varion-pdp-context', mode);
    }

    if (productInfo) {
      productInfo.setAttribute('data-varion-pdp-context', mode);
    }

    if (productRoot) {
      productRoot.setAttribute('data-varion-context', mode);
    }

    document.dispatchEvent(
      new CustomEvent('varion:breadcrumb-context', {
        detail: {
          rootType: mode,
          trail: Array.isArray(trail) ? trail.slice() : []
        }
      })
    );
  }

  function renderProductBreadcrumb() {
    var nav = document.querySelector('.varion-pdp-breadcrumb');
    if (!nav) return;

    var list = nav.querySelector('.varion-pdp-breadcrumb__list');
    if (!list) return;

    var productTitle = nav.dataset.productTitle || document.title;
    var productPath = cleanPath(nav.dataset.productUrl || window.location.pathname);
    var stored = readTrail();
    var trail = null;
    var rootType = nav.dataset.defaultRootType || 'online';

    if (
      stored &&
      stored.productPath &&
      cleanPath(stored.productPath) === productPath &&
      Array.isArray(stored.trail) &&
      stored.trail.length
    ) {
      trail = stored.trail;
      rootType = stored.rootType || rootType;
    }

    if (!trail) {
      var referrerTrail = buildTrailFromReferrer();
      if (referrerTrail && Array.isArray(referrerTrail.trail) && referrerTrail.trail.length) {
        trail = referrerTrail.trail;
        rootType = referrerTrail.rootType || rootType;
      }
    }

    if (!trail || !trail.length) {
      trail = buildFallbackTrail(nav);
    }

    list.innerHTML = '';

    trail.forEach(function (item) {
      if (!item || !item.label) return;

      var li = document.createElement('li');
      li.className = 'varion-pdp-breadcrumb__item';

      if (item.url) {
        var link = document.createElement('a');
        link.className = 'varion-pdp-breadcrumb__link';
        link.href = item.url;
        link.textContent = item.label;
        li.appendChild(link);
      } else {
        li.textContent = item.label;
      }

      list.appendChild(li);
    });

    var current = document.createElement('li');
    current.className = 'varion-pdp-breadcrumb__item';
    current.setAttribute('aria-current', 'page');

    var currentLabel = document.createElement('span');
    currentLabel.className = 'varion-pdp-breadcrumb__current';
    currentLabel.textContent = productTitle;
    current.appendChild(currentLabel);
    list.appendChild(current);

    applyProductContext(rootType, trail);
  }

  bindCollectionClicks();
  renderProductBreadcrumb();
})();
